import { styled, keyframes } from "styled-components";
import { Assets } from "../../../../common/styles/assets";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;


export const Wrapper = styled.div`
  width: 600px;
  height: auto;
  display: flex;
  flex-direction: column;  
  margin-top: 120px;
  box-sizing: border-box;
  @media (max-width: 768px) {
    width: 100%;
    padding: 10px;
  } 
`;

export const SessionExecutionContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; 
  box-sizing: border-box;
  padding: 20px;  
  border-radius: 10px;
  margin-top: 40px;
  @media (max-width: 768px) {
    margin-top: 50px;
  }    
`;

export const ActionDescription = styled.p`
  font-size: 45px;
  font-family: 'Ubuntu', Arial, sans-serif;
  color: #fff;
  padding:0;  
  text-align: center;
  font-weight: bold;
  margin:0;
  animation: ${fadeIn} 0.5s ease-out forwards;
`;

export const ButtonContainer = styled.div`
  width: 200px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 40px;
`;

export const ActionsBarWrapper = styled.div`
  width: auto;
  max-width: 480px;
  height: auto;  
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
  }    
`;


export const ButtonOk = styled.button`
width: 100%;
height: 60px;  
text-decoration: none;
display: flex;
justify-content: center;
align-items: center;
background: transparent;
border: 3px solid ${Assets.primaryColor};
color: ${Assets.primaryColor};  
border-radius: 5px;  
cursor: pointer;
font-family: 'Ubuntu', Arial, sans-serif;
font-size: 16px;
font-weight: bold;
margin-top: 20px;
&:hover {
  background: ${Assets.primaryColor};
  color: #000;
}
`;

export const ButtonFail = styled.button`
width: 100%;
height: 60px;  
text-decoration: none;
display: flex;
justify-content: center;
align-items: center;
background: transparent;
border: 3px solid ${Assets.redColor};
color: ${Assets.redColor};  
border-radius: 5px;  
cursor: pointer;
font-family: 'Ubuntu', Arial, sans-serif;
font-size: 16px;
font-weight: bold;
margin-top: 20px;
&:hover {
  background: ${Assets.redColor};
  color: #000;
}
`;

export const FinishSessionContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;  
  font-size: 15px;
  cursor: pointer;
  text-decoration: underline;

`;

export const SessionTopMenuContainer = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  background: rgba(0, 0, 0, 0.6);
  border-bottom: 1px solid #2a2a2a;
`;

export const SessionTopMenuWrapper = styled.div`
  width: 900px;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const LogoImg = styled.img`
  width: 120px;    
  height: 35px;
`;

export const ArrowControlsWrapper = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin: 60px auto 0;
  gap: 20px;
`;

export const ArrowButton = styled.button<{ $selected?: boolean }>`
  width: min(120px, 28vw);
  height: min(120px, 28vw);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 16px;
  font-size: 56px;
  background: ${({ $selected }) => ($selected ? Assets.primaryColor : "transparent")};
  color: ${({ $selected }) => ($selected ? "#000" : Assets.primaryColor)};
  border: 3px solid ${Assets.primaryColor};
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
`;

